var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlogIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.891,
    height: 20,
    viewBox: "0 0 19.891 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "blog",
    d: "M20.68,8.861a1.539,1.539,0,0,0-.36-1.087,1.4,1.4,0,0,0-1.079-.422l-1.148,0c-.475,0-.675-.567-.948-1.5l-.059-.2A9.993,9.993,0,0,0,14.9,1.7,4.744,4.744,0,0,0,11.5,0H7.235A6.452,6.452,0,0,0,.793,6.447v7.118A6.446,6.446,0,0,0,7.235,20H14.24a6.472,6.472,0,0,0,6.443-6.435ZM6.312,5.042h4.23a1.379,1.379,0,1,1,0,2.759H6.312a1.379,1.379,0,0,1,0-2.759Zm8.594,9.732H6.312a1.379,1.379,0,0,1,0-2.759h8.594a1.379,1.379,0,0,1,0,2.759Z",
    transform: "translate(-0.793)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogIcon);
export default __webpack_public_path__ + "static/media/blogIcon.ba4641ba940dbc982cad0619a9bebd85.svg";
export { ForwardRef as ReactComponent };